<script lang="ts">
  import TimelineSection from "./LitigationTimeline/TimelineSection.svelte";
  import type { TimelineEntry, EntryStatus } from "./LitigationTimeline/types";

  let {
    title,
    description_html,
    entries,
    name,
  }: {
    title: string;
    description_html: string;
    entries: TimelineEntry[];
    name: string;
  } = $props();

  const { current, past, future } = $derived.by(() => {
    return entries.reduce<Record<EntryStatus, TimelineEntry[]>>((memo, entry) => {
      memo[entry.status].push(entry);
      return memo;
    }, {current: [], past: [], future: []});
  })
</script>

<div class="rounded bg-white p-4 lg:p-6">
  <h2 class="ui-title mb-2">{title}</h2>
  <p class="text-sm text-gray-600 mb-6">{@html description_html}</p>

  {#if current.length}
    <div class="border rounded-lg p-4 pb-3 relative flex flex-col gap-2">
      <div class="absolute -top-3 text-sm font-medium text-sky-700 bg-sky-100 py-0.5 px-2 rounded-badge">
        Current {current.length === 1 ? "stage" : "stages"}
      </div>
      {#each current as entry}
        <div>
          <div class="font-medium mb-1">{entry.title}</div>
          <div class="text-sm text-gray-600">{@html entry.description_html}</div>
        </div>
      {/each}
    </div>
  {/if}

  <div class="divide-y">
    {#if past.length}
      <TimelineSection
        label="Completed {past.length === 1 ? "stage" : "stages"}"
        entries={past}
        name="{name}_past_timeline"
        done={true}
      />
    {/if}
    {#if future.length}
      <TimelineSection
        label="Remaining {future.length === 1 ? "stage" : "stages"}"
        entries={future}
        name="{name}_future_timeline"
      />
    {/if}
  </div>
</div>
